import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'

Vue.prototype.$apiAdress = process.env.VUE_APP_apiUrl
// Vue.prototype.$apiAdress = 'http://127.0.0.1:8000'
// Vue.prototype.$apiAdress = 'https://kianseng.org'
Vue.config.performance = true
Vue.use(CoreuiVue)
//---------------------------------------
import * as tzsciDeclare from "@/views/tzsci/js/tzsciDeclare.js"
import * as kiansengDeclare from "@/views/rotary/js/rotaryDeclare"


if (process.env.VUE_APP_siteType==="kianseng"){
  Vue.prototype.$u=kiansengDeclare;
}else if (process.env.VUE_APP_siteType==="tzSci"){
  Vue.prototype.$u=tzsciDeclare;
}


//---------------------------------------
// import declare from "./util/declare";
// Vue.prototype.$d = declare
//---------------------------------------
import vuetify from './views/plugins/vuetify';
//---------------------------------------
import CKEditor from 'ckeditor4-vue';
Vue.use(CKEditor);
//---------------------------------------
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
//---------------------------------------
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
//---------------------------------------
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
//---------------------------------------
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

// vue-loading-overlay
// Vue.use(VueLoading); //Use default options
Vue.use(VueLoading, {
  canCancel: true,
  color: '#000000',
  loader: 'dots', //spinner/dots/bars
  width: 50,
  height: 50,
  backgroundColor: '#ffffff',
  isFullPage: true,
  opacity: 0.8
});
//---------------------------------------
import { ValidationObserver,ValidationProvider, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { localize } from 'vee-validate';
import zh_TW from 'vee-validate/dist/locale/zh_TW.json';


Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize('zh_TW',zh_TW);

localize({
  zh_TW: {
    messages: {
      required: '必填', //'「{_field_}」為必填'
      email:'須為有效的電子信箱',
      min: 'this field must have no less than {length} characters',
      max: (_, { length }) => `this field must have no more than ${length} characters`
    }
  }
});
//---------------------------------------
import VoerroTagsInput from '@voerro/vue-tagsinput';

Vue.component('tags-input', VoerroTagsInput);
//---------------------------------------
import VueGoodTablePlugin from 'vue-good-table';

// import the styles
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin);

//---------------------------------------
import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(VueQrcodeReader);

//---------------------------------------
import "vue-easytable/libs/theme-default/index.css";
import VueEasytable from "vue-easytable";

Vue.use(VueEasytable);
//---------------------------------------
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
//---------------------------------------
import Dice from 'vue-dice-component'

Vue.use(Dice);

//---------------------------------------
Vue.filter('fmtDate', function (value) {
  if (!value) return ''

  return value.substr(0,19).replaceAll("T"," ")
})

Vue.filter('nullToEmpty', function (value) {
  if (!value) {
    return ''
  }else{
    return value;
  }
})
//---------------------------------------

new Vue({
  el: '#app',
  router,
  vuetify,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  },
})
